export default __webpack_public_path__ + "static/syncstage-built-for-consistency-b7fb4bb0b8b16d88f46da3f36d74c552.png";